import { Box, LoadingOverlay, Title } from '@mantine/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { getApiError } from '@/api/helpers/apiError'
import { AuthLayout } from '@/components/layout/AuthLayout/AuthLayout'
import { useInviteMembers } from '@/queries/workspaceQueries'
import { showToast } from '@/theme/notifications'
import { InviteMembersForm, SubmitValues } from './InviteMembersForm'

type InviteMembersHandlerProps = {
  workspaceId: string
  onCompleted: () => void
}

export const InviteMembersHandler = ({
  workspaceId,
  onCompleted
}: InviteMembersHandlerProps) => {
  const intl = useIntl()

  const { mutateAsync: inviteMembers, isPending } = useInviteMembers()

  const handleInviteMembers = async ({ members }: SubmitValues) => {
    try {
      await inviteMembers({
        workspaceId,
        members
      })

      showToast(
        intl.formatMessage({ id: 'workspace.members.invite.success' }),
        'success'
      )

      onCompleted()
    } catch (err) {
      const { errorMessage } = getApiError(err)

      const message =
        errorMessage ||
        intl.formatMessage({ id: 'workspace.members.invite.error' })

      showToast(message, 'error')
    }
  }

  return (
    <AuthLayout variant="large">
      <Box pos="relative">
        <LoadingOverlay visible={isPending} />

        <Title order={2} mb="xl">
          <FormattedMessage id="workspace.members.invite" />
        </Title>

        <InviteMembersForm
          showSkipButton
          onSkip={onCompleted}
          onSubmit={(values) => void handleInviteMembers(values)}
        />
      </Box>
    </AuthLayout>
  )
}
